import { DialogConfig } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { DownloadHistoryDialogComponent } from '../../download-history/download-history-dialog/download-history-dialog.component';

@Component({
    selector: 'app-search-filter-dialog',
    templateUrl: './search-filter-dialog.component.html',
    styleUrls: ['./search-filter-dialog.component.less'],
    standalone: false
})
export class SearchFilterDialogComponent  implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogConfig: DialogConfig,
    public dialog: MatDialogRef<DownloadHistoryDialogComponent>,
    protected srvRpDesign: ResponsiveDesignService
  ) {
   }

  ngOnInit() {}

  callback(_event: any): void {
    this.dialog.close();
  }  
}
